import { Portfolio } from '../../domain/entities/portfolio.entity';

export interface PortfolioApiResponse {
  id: string;
  code: string | null;
  name: string | null;
  description: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  ordersCount?: number;
}

export interface PortfolioListPagedApiResponse {
  items: PortfolioApiResponse[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
  orderField?: string;
  ascendingOrder: boolean;
}

export class PortfolioMapper {
  static toDomain(raw: PortfolioApiResponse): Portfolio {
    return {
      id: raw.id,
      code: raw.code ?? null,
      name: raw.name,
      description: raw.description,
      createdAt: raw.createdAt ? new Date(raw.createdAt) : new Date(0),
      updatedAt: raw.updatedAt ? new Date(raw.updatedAt) : undefined,
      ordersCount: raw.ordersCount ?? 0,
    };
  }

  static toDomainList(rawList: PortfolioApiResponse[]): Portfolio[] {
    return rawList.map((raw) => this.toDomain(raw));
  }

  static sortFieldToApi(field: string): string {
    const mapping: Record<string, string> = {
      id: 'id',
      name: 'name',
      createdAt: 'createdat',
      updatedAt: 'updatedat',
    };
    return mapping[field] ?? field.toLowerCase();
  }

  static dateFilterToIso(value: unknown): string {
    const date = value instanceof Date ? value : new Date(value as string);
    return date.toISOString();
  }
}
